

{
  "familyId": "MET-MEETK-OMTREK",
  "questions": [
    {
      "id": "MET-MEETK-OMTREK-001",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een straal van 5 cm. Wat is de omtrek? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["31,4 cm", "15,7 cm", "78,5 cm", "10 cm"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"highlightRadius":true,"label":"Cirkel met straal 5 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek cirkel","content":"Omtrek = 2 × π × straal = 2 × 3,14 × 5 = 31,4 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De formule voor de omtrek is: omtrek = 2 × π × straal. Reken stap voor stap: 2 × 3,14 = 6,28, dan 6,28 × 5 = 31,4 cm. Snelle controle: de omtrek is altijd iets meer dan 3 × diameter, dus iets meer dan 30 cm — klopt.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × π × straal",
          "Vul in: 2 × 3,14 × 5",
          "Reken: 2 × 3,14 = 6,28 → 6,28 × 5 = 31,4 cm",
          "Check: omtrek ≈ 3× diameter = 30 → klopt"
        ],
        "distractorExplanations": {
          "0": "Goed! Omtrek = 2 × π × straal = 2 × 3,14 × 5 = 31,4 cm.",
          "1": "Je hebt de factor 2 vergeten en alleen π × straal gerekend (3,14 × 5 = 15,7). Maar de formule is 2 × π × straal. Onthoud: zonder de 2 reken je een halve omtrek.",
          "2": "Je hebt de oppervlakteformule gebruikt: π × straal² = 3,14 × 25 = 78,5 cm². Maar de vraag is naar de omtrek (lengte, in cm), niet de oppervlakte (vlak, in cm²). Onthoud: omtrek = 2πr, oppervlakte = πr².",
          "3": "Je hebt de diameter gegeven (2 × 5 = 10 cm). Maar de omtrek loopt rond de cirkel — veel langer dan de diameter. Onthoud: omtrek = π × diameter ≈ 3,14 × diameter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.cirkel-omtrek-zonder-factor-2", "label": "Factor 2 vergeten", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-als-oppervlakte", "label": "Oppervlakteformule gebruikt", "optionIndex": 2 },
          { "id": "met.cirkel-omtrek-diameter-i.p.v.-formule", "label": "Diameter als omtrek", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-002",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "De diameter van een cirkel is 10 cm. Wat is de omtrek? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["15,7 cm", "62,8 cm", "31,4 cm", "314 cm"],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"diameter":10,"highlightDiameter":true,"label":"Cirkel met diameter 10 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek met diameter","content":"Omtrek = π × diameter = 3,14 × 10 = 31,4 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_diameter",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Met de diameter is de formule: omtrek = π × diameter = 3,14 × 10 = 31,4 cm. (Of via de straal: straal = 5, dan 2 × 3,14 × 5 = 31,4 cm — zelfde antwoord.) Onthoud: π × diameter en 2 × π × straal geven hetzelfde, want diameter = 2 × straal.",
        "solutionSteps": [
          "Kies de handigste formule: omtrek = π × diameter",
          "Vul in: 3,14 × 10",
          "Bereken: 3,14 × 10 = 31,4 cm"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk de straal gebruikt (5) i.p.v. de diameter (10) en met π vermenigvuldigd: 3,14 × 5 = 15,7. De formule is echter π × diameter, niet π × straal. Onthoud: π × diameter = 2 × π × straal.",
          "1": "Je hebt 2 × π × diameter gerekend (= 62,8). Dat is een dubbele factor 2 — π × diameter is al gelijk aan 2πr. Onthoud: óf π × diameter, óf 2 × π × straal — niet allebei tegelijk.",
          "2": "Goed! π × diameter = 3,14 × 10 = 31,4 cm.",
          "3": "Je hebt 3,14 × 100 berekend. Maar de diameter is 10 cm, niet 100 cm. Onthoud: lees de eenheid en de waarde zorgvuldig af."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-i.p.v.-diameter-formule", "label": "Straal i.p.v. diameter", "optionIndex": 0 },
          { "id": "met.cirkel-omtrek-2pi-keer-d", "label": "Dubbele factor 2", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-eenheid-fout", "label": "Verkeerd getal/eenheid", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-003",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een omtrek van 62,8 cm. Wat is de straal? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["20 cm", "10 cm", "5 cm", "31,4 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":10,"label":"Cirkel met omtrek 62,8 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Straal uit omtrek","content":"Omtrek = 2 × π × straal, dus straal = omtrek ÷ (2π) = 62,8 ÷ 6,28 = 10 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_radius_from_circumference",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Begin bij omtrek = 2 × π × straal en draai de formule om: straal = omtrek ÷ (2 × π). Bereken eerst de noemer: 2 × 3,14 = 6,28. Dan: 62,8 ÷ 6,28 = 10 cm. Controleer: 2 × 3,14 × 10 = 62,8 ✓. Onthoud: bij terugrekenen ondoe je beide bewerkingen — delen door 2 én door π.",
        "solutionSteps": [
          "Begin met: omtrek = 2 × π × straal",
          "Draai om: straal = omtrek ÷ (2 × π)",
          "Reken noemer: 2 × 3,14 = 6,28",
          "Deel: 62,8 ÷ 6,28 = 10 cm",
          "Check: 2 × 3,14 × 10 = 62,8 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de diameter berekend (62,8 ÷ π ≈ 20 cm), niet de straal. Onthoud: deel óók nog door 2 om bij de straal te komen, of deel direct door (2 × π).",
          "1": "Goed! Straal = 62,8 ÷ (2 × 3,14) = 62,8 ÷ 6,28 = 10 cm.",
          "2": "Je hebt door een te grote factor gedeeld (waarschijnlijk 4π ≈ 12,56). De juiste deler is 2π = 6,28: 62,8 ÷ 6,28 = 10 cm. Onthoud: precies 2π, niet meer.",
          "3": "Je hebt 62,8 ÷ 2 = 31,4 gerekend en de π weggelaten. Maar in de omtrekformule zit zowel een 2 als een π. Onthoud: deel altijd door 2π, niet door 2 alleen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-uit-omtrek-deel-pi", "label": "Alleen ÷ π (geeft diameter)", "optionIndex": 0 },
          { "id": "met.cirkel-straal-uit-omtrek-deel-vier-pi", "label": "÷ 4π i.p.v. ÷ 2π", "optionIndex": 2 },
          { "id": "met.cirkel-straal-uit-omtrek-deel-2", "label": "Alleen ÷ 2 (π vergeten)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-004",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een fietswiel heeft een diameter van 70 cm. Hoeveel centimeter legt het wiel af in één omwenteling? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["109,9 cm", "439,6 cm", "70 cm", "219,8 cm"],
      "correctAnswer": 3,
      "stimulusAids": [{"type":"circle","data":{"diameter":70,"highlightDiameter":true,"label":"Fietswiel ∅ 70 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Eén omwenteling = omtrek","content":"Eén ronde van het wiel = de omtrek = π × diameter = 3,14 × 70 = 219,8 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_context",
      "variantIndex": 4,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Eén omwenteling van een wiel = exact de omtrek. Omtrek = π × diameter = 3,14 × 70 = 219,8 cm. Het wiel rolt dus elke ronde 219,8 cm verder over de grond. Onthoud: 1 omwenteling = 1× de omtrek.",
        "solutionSteps": [
          "Inzicht: 1 omwenteling = 1× de omtrek",
          "Formule: omtrek = π × diameter",
          "Invullen: 3,14 × 70 = 219,8 cm"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk de straal gebruikt: 3,14 × 35 = 109,9 cm. Maar de formule met diameter is π × diameter. Onthoud: gebruik óf 2πr, óf πd — niet π × straal.",
          "1": "Je hebt 2 × π × diameter gerekend (= 439,6) — een dubbele factor 2. π × diameter = 2πr, dus de extra ×2 is teveel. Onthoud: óf πd, óf 2πr.",
          "2": "Je hebt 70 cm gegeven. Maar 70 cm is de diameter, niet de afstand die het wiel aflegt. De omtrek = π × 70 ≈ 220 cm — ruim 3 keer zoveel.",
          "3": "Goed! π × 70 = 219,8 cm per omwenteling."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-i.p.v.-diameter-formule", "label": "Straal i.p.v. diameter", "optionIndex": 0 },
          { "id": "met.cirkel-omtrek-2pi-keer-d", "label": "Dubbele factor 2", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-diameter-i.p.v.-formule", "label": "Diameter als omtrek", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-005",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "De omtrek van een cirkel is 94,2 cm. Wat is de diameter? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["15 cm", "30 cm", "47,1 cm", "60 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"diameter":30,"label":"Cirkel met omtrek 94,2 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Diameter uit omtrek","content":"Omtrek = π × diameter, dus diameter = omtrek ÷ π = 94,2 ÷ 3,14 = 30 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_diameter_from_circumference",
      "variantIndex": 5,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Begin met omtrek = π × diameter en draai om: diameter = omtrek ÷ π = 94,2 ÷ 3,14 = 30 cm. Controleer: 3,14 × 30 = 94,2 ✓. Onthoud: deel altijd door π — niet door 2 of door 2π — om de diameter terug te vinden.",
        "solutionSteps": [
          "Begin met: omtrek = π × diameter",
          "Draai om: diameter = omtrek ÷ π",
          "Vul in: 94,2 ÷ 3,14 = 30 cm",
          "Check: 3,14 × 30 = 94,2 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de straal berekend (94,2 ÷ 6,28 = 15) i.p.v. de diameter. Onthoud: voor de diameter deel je door π alleen, niet door 2π.",
          "1": "Goed! 94,2 ÷ 3,14 = 30 cm.",
          "2": "Je hebt de omtrek door 2 gedeeld (94,2 ÷ 2 = 47,1) en de π weggelaten. Maar diameter = omtrek ÷ π, niet ÷ 2. Onthoud: π hoort er bij.",
          "3": "Je hebt door een te kleine factor gedeeld. De juiste deler is precies π = 3,14: 94,2 ÷ 3,14 = 30 cm. Onthoud: deel exact door π."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-uit-omtrek-deel-vier-pi", "label": "÷ 2π geeft straal", "optionIndex": 0 },
          { "id": "met.cirkel-diameter-uit-omtrek-deel-2", "label": "÷ 2 (π vergeten)", "optionIndex": 2 },
          { "id": "met.cirkel-diameter-uit-omtrek-deel-fout", "label": "Verkeerde deler", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-006",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "fill_in",
      "question": "Een tuinontwerper maakt een rond bloembed met een straal van 4 meter. Wat is de omtrek in meters? (π ≈ 3,14, rond af op 1 decimaal)",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["25,1", "25.1", "25,12", "25.12"],
        "caseSensitive": false,
        "placeholder": "... m"
      },
      "stimulusAids": [{"type":"circle","data":{"radius":4,"highlightRadius":true,"label":"Rond bloembed met straal 4 m"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek cirkel","content":"Omtrek = 2 × π × straal = 2 × 3,14 × 4 = 25,12 m → 25,1 m (1 decimaal).","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Omtrek = 2 × π × straal = 2 × 3,14 × 4. Stap voor stap: 2 × 3,14 = 6,28, dan 6,28 × 4 = 25,12 m. Afgerond op 1 decimaal: 25,1 m. De tuinontwerper heeft dus ruim 25 meter randmateriaal nodig.",
        "solutionSteps": [
          "Formule: omtrek = 2 × π × straal",
          "Invullen: 2 × 3,14 × 4",
          "Stap voor stap: 2 × 3,14 = 6,28 → 6,28 × 4 = 25,12 m",
          "Afronden op 1 decimaal: 25,1 m"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}

